import { Services } from '@sigma-frontend-libs/commons'

import { getIconSVGByType, permissionPresets } from '@/utils'

import render from './render'

export default {
  name: 'Panel',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    canGetUsersAsResellerUp() {
      return this.checkPermissions(`advanced.${Services.users}.get`, permissionPresets.resellerUp)
    },
    canGetSendernamesAsUser() {
      return this.checkPermissions(`advanced.${Services.sendernames}.get`, permissionPresets.me)
    },

    ownerId() {
      return this.value.OwnerId || this.value.Owner?.id
    },

    isAttached() {
      return this.ownerId !== this.account?.id
    },

    iconSVG() {
      return getIconSVGByType(this.value.type)
    }
  },

  render
}
